// src/components/admin/tenant/TenantIndex.tsx

import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import TenantsList from './TenantsList';
import TenantListPage from './TenantListPage';
import TenantForm from './TenantForm';
import AboutSection from '../../AboutSection';

const isAdmin = true; // Replace with real auth logic

// Dynamic wrapper to map route to mode
const TenantFormWrapper: React.FC = () => {
    const location = useLocation();
    const pathname = location.pathname;
  
    let mode: 'create' | 'edit' | 'view' = 'view';
  
    if (pathname.endsWith('/create')) mode = 'create';
    else if (pathname.endsWith('/edit')) mode = 'edit';
  
    console.log('🚀 Mode:', mode, 'Path:', pathname);
  
    return   <div className="min-h-screen bg-gray-100 flex flex-col  w-full  p-2 ">
    <AboutSection title={"Tenant - " + mode} iconName="home"></AboutSection>
    <TenantForm mode={mode} />
  </div>;
  };

export default function TenantsModule() {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<TenantListPage />} />
      <Route path="create" element={<TenantFormWrapper />} />
      <Route path=":id" element={<TenantFormWrapper />} />
      <Route path=":id/edit" element={<TenantFormWrapper />} />
    </Routes>
  );
}